import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Call from "@/pages/Call";
import { InstallButton } from "@/components/PWAInstall";
import { Phone, DeviceMobile, Hash, Stack, Storefront } from "@phosphor-icons/react";

// Standalone "iYeneh Dialer" mini-app. Swaps in its own PWA manifest so it can be
// installed as a separate home-screen icon, distinct from the main website app.
export default function DialerApp() {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    const prev = link ? link.getAttribute("href") : null;
    if (link) link.setAttribute("href", "/dialer-manifest.json");
    document.title = "iYeneh Dialer";
    return () => { if (link && prev) link.setAttribute("href", prev); };
  }, []);

  const quick = [
    { to: "/pricing", label: "Phone Plans", icon: Phone },
    { to: "/app/numbers", label: "DIDs / Numbers", icon: Hash },
    { to: "/app/pbx", label: "Cloud PBX", icon: Stack },
    { to: "/shop", label: "Devices", icon: Storefront },
  ];

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="dialer-app">
      <header className="sticky top-0 z-40 border-b border-border bg-background/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-3">
          <Link to="/dialer" className="flex items-center gap-2">
            <img src="/icons/dialer-512.png" alt="iYeneh Dialer" className="h-8 w-8 rounded-lg" />
            <span className="text-base font-bold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>iYeneh Dialer</span>
          </Link>
          <div className="flex items-center gap-2">
            <InstallButton testid="dialer-install-app" className="inline-flex items-center gap-1.5 rounded-full bg-primary px-3.5 py-2 text-xs font-bold text-primary-foreground">
              <DeviceMobile size={15} weight="fill" /> Install App
            </InstallButton>
            <Link to="/app" data-testid="dialer-my-account" className="rounded-full border border-border px-3.5 py-2 text-xs font-semibold hover:border-primary">My Account</Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-4 py-5">
        <Call />
      </main>

      <section className="mx-auto max-w-2xl px-4 pb-10">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Add to your line</p>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {quick.map((q) => (
            <Link key={q.to} to={q.to} data-testid={`dialer-buy-${q.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="flex flex-col items-center gap-1.5 rounded-2xl border border-border bg-card p-4 text-center transition-transform hover:-translate-y-0.5 hover:border-primary">
              <q.icon size={22} weight="duotone" className="text-primary" />
              <span className="text-xs font-semibold">{q.label}</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
